@if (tile() && tileListUtils.isTile(tile())) {
    <div priva-card class="tile" [hasImage]="false" [hasBody]="true" [attr.data-test]="'tile-' + tile().id">
        <div class="tile__content">
            <div class="tile__circle">
                <span [class]="tile().iconClass + ' tile__circle--icon'">{{ tile().iconText }}</span>
            </div>
            <div class="tile__content--label">{{ tile().name | translate }}</div>
        </div>
    </div>
}
